// @flow
import { parsePhoneNumber } from 'libphonenumber-js';
import startsWith from 'lodash/startsWith';
import useSelfEnrollment from '../../hooks/useSelfEnrollment';

const useContactNumber = () => {
  const { entityData } = useSelfEnrollment();
  const { orgPhone, selfEnrollment } = entityData || {};
  const contactNumber = selfEnrollment?.selfEnrollmentSupportNumber ?? orgPhone ?? '';

  if (!contactNumber) return '';
  if (startsWith(contactNumber, '+')) return parsePhoneNumber(contactNumber).formatInternational();
  return parsePhoneNumber(`+1${contactNumber}`).formatNational();
};

export default useContactNumber;
